import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './UserProfilePage.module.scss';
import clsx from 'clsx';
import ProfileBlock from '../../components/ProfileBlock/ProfileBlock';
import Layout from '../../components/Layout/Layout';
import Row from '../../components/Row/Row';
import Block from '../../components/Block/Block';
import { userTransactionHistory } from '../../redux/actions/user/userTransactionHistory';
import dayjs from 'dayjs';
const UserProfilePage = () => {
  // const data = [
  //   '22.01.2000',
  //   'Genshin Impact',
  //   'tulen.store',
  //   '100 ₽',
  //   '+3 ₽',
  //   '334376',
  //   '22.01.2000',
  //   'Genshin Impact',
  //   'tulen.store',
  //   '100 ₽',
  //   '+3 ₽',
  //   '334376',
  //   '22.01.2000',
  //   'Genshin Impact',
  //   'tulen.store',
  //   '100 ₽',
  //   '+3 ₽',
  //   '334376',
  //   '22.01.2000',
  //   'Genshin Impact',
  //   'tulen.store',
  //   '100 ₽',
  //   '+3 ₽',
  //   '334376',
  //   ,
  //   '22.01.2000',
  //   'Genshin Impact',
  //   'tulen.store',
  //   '100 ₽',
  //   '+3 ₽',
  //   '334376',
  //   '22.01.2000',
  //   'Genshin Impact',
  //   'tulen.store',
  //   '100 ₽',
  //   '+3 ₽',
  //   '334376',
  //   ,
  //   '22.01.2000',
  //   'Genshin Impact',
  //   'tulen.store',
  //   '100 ₽',
  //   '+3 ₽',
  //   '334376',
  //   '22.01.2000',
  //   'Genshin Impact',
  //   'tulen.store',
  //   '100 ₽',
  //   '+3 ₽',
  //   '334376',
  // ];

  const dispatch = useDispatch();
  const {
    userTransactionHistory: { data: userTransactionHistoryData, loading: userTransactionHistoryLoading, error: userTransactionHistoryError },
  } = useSelector((state) => state.user);
  useEffect(() => {
    dispatch(userTransactionHistory());
  }, []);
  const [data, setData] = useState([]);
  useEffect(() => {
    if (userTransactionHistoryData) {
      let list = [];

      userTransactionHistoryData?.map((item) => {
        list.push(dayjs(item?.createdAt).format('HH:mm DD.MM.YYYY'));
        list.push(item?.serviceGame?.game?.name);
        list.push(item?.serviceGame?.service?.name);
        list.push(`${item?.sumWithDiscount} ₽`);
        list.push(`+${item?.sumDiscount} ₽`);
        list.push(item?.playerId);
      });
      setData(list);
      console.log(list);
    }
  }, [userTransactionHistoryData]);

  return (
    <>
      <>
        <div className="wrap">
          <ProfileBlock>
            <Row label="Pass ID" value={'1234'} />
          </ProfileBlock>
          <Block title="Донаты" className={styles.donation}>
            <div className={clsx(styles.tabel)}>
              {data?.map((item) => (
                <div className={clsx(styles.cell)}>{item}</div>
              ))}
            </div>
          </Block>
        </div>
      </>
    </>
  );
};

export default UserProfilePage;
